module.exports = __webpack_public_path__ + "img/07_shimizu_10.5b6e89de.jpg";